// composables/useConfirmModal.ts
interface ConfirmOptions {
    title: string
    text: string
    options?: object
  }
  
  export const useConfirmModal = () => {
    const state = useConfirmModalState()
  
    const confirm_modal_show = ({ title, text, options }: ConfirmOptions): Promise<boolean> => {
      return new Promise((resolve) => {
        state.value = {
          isOpen: true,
          title,
          text,
          options: options || {},
          callback: (result: boolean) => {
            resolve(result)
          }
        }
      })
    }
  
    return {
      confirm_modal_show: confirm_modal_show
    }
  }